import LogoCarousel from "../../components/LogoCarousel/LogoCarousel";
import Button from "../../components/Button/Button.js"
import HeroVideo from "../../assets/videos/hero-bluekali.mp4"
// import SharkySticker from "../../assets/images/Sharky/Sharky_Waving.png"
// import { useState, useEffect } from 'react'
// import StickerContainer from "../../components/Sticker/StickerContainer.js";
// import DraggableSticker from "../../components/Sticker/DraggableSticker.js";

import { useTranslation } from 'react-i18next';
import gsap from 'gsap'
import { ScrollSmoother } from 'gsap/ScrollSmoother'
gsap.registerPlugin(ScrollSmoother)

function Hero({className}) {
    // const [stickers,setStickers] = useState([]);

    // useEffect(() => {
    //     const width = window.innerWidth;
    //     const height = window.innerHeight;

    //     setStickers([
    //     {
    //       id: 1,
    //       src: SharkySticker,
    //       initialX: width*0.8,
    //       initialY: height*0.7,
    //       size: 80
    //     },
    //     {
    //       id: 2,
    //       src: SharkySticker,
    //       initialX: width*0.4,
    //       initialY: height*0.2,
    //       size: 60
    //     }
    //   ])
    // }, [])

    const scrollToSolutions = () => {
        console.log("joa")
        const scrollTarget = document.getElementById('section-solutions')
        
        ScrollSmoother.get()?.scrollTo(scrollTarget, true)

        if (!ScrollSmoother.get()) {
            // console.log("scroll movil")
            scrollTarget.scrollIntoView()
        }
    };

    const scrollToWear = () => {
        const scrollTarget = document.getElementById('section-wear')
        
        ScrollSmoother.get()?.scrollTo(scrollTarget, true)

        if (!ScrollSmoother.get()) {
            // console.log("scroll movil")
            scrollTarget.scrollIntoView()
        }
    }

    const { t } = useTranslation(['common', 'navigation']);
  
    // const changeLanguage = (lng) => {
    //     i18n.changeLanguage(lng);
    // };

    return(
        <div id="section-hero" className={`flex flex-col justify-end w-full h-screen items-center ${className} space-y-4 bg-bluekali-cerulean-blue`}>

            <div>
                <video 
                autoPlay 
                muted 
                loop 
                playsInline
                className="absolute top-0 left-0 w-full h-screen object-cover z-0"
                poster="path/to/poster-image.jpg" //TODO: IMAGE WHILE LOADING
            >
                <source src={HeroVideo} type="video/mp4" />
                Your browser does not support HTML5 video.
            </video>
            
            <div className="absolute top-0 left-0 w-full h-screen bg-gradient-to-bl from-bluekali-navy-blue to-bluekali-cerulean-blue opacity-50 z-10"></div>
            </div>
            

        <div className="flex justify-start w-full z-20">
            <h3 className="text-bluekali-gray text-[15px] pl-6 w-5/6 md:w-96">{t('overtitle_paragraph')}</h3>
        </div>

        <div className="flex flex-col justify-start w-full pl-6 z-20">
            <h1 className="font-black  text-5xl md:text-6xl text-bluekali-tomato">{t('hero_title_1')}</h1>
            <h1 className="font-medium text-5xl md:text-6xl text-bluekali-white">{t('hero_title_2')}</h1>
        </div>

        <div className="flex z-50 w-full pl-6">
            <div className="flex flex-col items-start space-y-3">
                <Button filled='nietenaambonoo, oden ni sooro' className="md:hover:px-24 transition-all duration-200 "
                onClick={() => scrollToSolutions()}>
                    <h3 className="font-bold text-bluekali-navy-blue">{t('cta_corporate')}</h3>
                </Button>
                <Button className="md:hover:px-24 transition-all duration-200"
                onClick={() => scrollToWear()}>
                    <h3 className="font-bold">{t('cta_individual')}</h3>
                </Button>
            </div>
        </div>
        
        <div className="hidden md:flex w-full justify-start md:pl-6 md:pt-8 z-20">
            <div className="flex flex-col w-full md:w-2/3 items-start bg-bluekali-white pl-6 md:px-4 py-2 md:rounded-lg">
                <p className="text-xs mb-1 text-bluekali-cerulean-blue font-bold test-animation">{t('partners')}</p>
                <LogoCarousel/>
                
            </div>
        </div>

        <div className="h-10 md:hidden"/>

        <div className="bg-bluekali-navy-blue h-10 w-full rounded-t-full z-20"/>

        {/* <div className="absolute top-0 left-0 h-full w-full hidden md:block">
            <StickerContainer>
            {stickers.map((sticker) => (
            <DraggableSticker
              key={`${sticker.id}-${sticker.initialX}-${sticker.initialY}`} // Re-render cuando cambien posiciones
              id={sticker.id}
              src={sticker.src}
              alt={`Sticker ${sticker.id}`}
              initialX={sticker.initialX}
              initialY={sticker.initialY}
              size={sticker.size}
              zIndex={sticker.id}
            />
          ))}
        </StickerContainer>
        </div> */}

        </div>
    );   
}

export default Hero;